var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "regist-input" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("section", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "input_list" }, [
            _vm.errorMessage.text
              ? _c("div", [
                  _c("label", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errorMessage.text))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.errors.email
              ? _c("div", [
                  _c("label", { staticClass: "error_text" }, [
                    _vm._v(_vm._s(_vm.errors.email))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("ul", [
              _vm._m(1),
              _vm._v(" "),
              _c("li", { staticClass: "input_mail_field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.mailAddress,
                      expression: "mailAddress",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "メールアドレスを入力してください。"
                  },
                  domProps: { value: _vm.mailAddress },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mailAddress = $event.target.value.trim()
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "detail_btn btn_pos_left",
                    on: {
                      click: function($event) {
                        _vm.sendMail()
                      }
                    }
                  },
                  [_vm._v("送信")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(2)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("パスワードのリセット")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_key" }, [
      _c("label", { staticClass: " text_left" }, [
        _vm._v("ご登録メールアドレス")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          ※受信制限をされている方は、「"),
      _c("span", { staticClass: "pickup" }, [_vm._v("@domans.co.jp")]),
      _vm._v("」からのメールを受信許可に設定してください"),
      _c("br"),
      _vm._v(
        "\n          ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。\n        "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-111e8d74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111e8d74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcPasswordResetInput.vue
// module id = null
// module chunks = 